"use strict";
var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");

var AbstractViewerController = require("./../../abstractViewerController.js");

var TriangleInteractionView = require("./triangleInteractionView.js");
var TriangleInteractionModel = require("./triangleInteractionModel.js");

var TriangleViewerController = function(archLayers, dependencies, configuration) {
    AbstractViewerController.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(TriangleViewerController, AbstractViewerController);
TriangleViewerController.inject = AbstractViewerController.inject;

module.exports = TriangleViewerController;

TriangleViewerController.prototype.beforeLoad = function () {
    AbstractViewerController.prototype.beforeLoad.call(this);
};

TriangleViewerController.prototype.getDataType = function () {
    return cio_datamodel.TriangleData;
};

TriangleViewerController.prototype.getInteractionViewType = function () {
    return TriangleInteractionView;
};

TriangleViewerController.prototype.getInteractionModelType = function () {
    return TriangleInteractionModel;
};
